import { render } from "./AllQuestions.vue?vue&type=template&id=e514518c&scoped=true"
import script from "./AllQuestions.vue?vue&type=script&lang=js"
export * from "./AllQuestions.vue?vue&type=script&lang=js"

import "./AllQuestions.vue?vue&type=style&index=0&id=e514518c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e514518c"]])

export default __exports__